import { isValid, parse } from "date-fns";

export const isValidDate = (dateStr: string) => {
	const regex = /(\d{4})-(\d{2})-(\d{2})$/;
	if (!regex.test(dateStr)) return false;

	const parsedDate = parse(dateStr, "yyyy-MM-dd", new Date());

	if (!isValid(parsedDate)) return false;

	return true;
};

// yyyyMMdd to yyyy-MM-dd
export const normalizeDateStr = (dateStr: string) => {
	if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;

	if (/^\d{8}$/.test(dateStr)) {
		const year = dateStr.slice(0, 4);
		const month = dateStr.slice(4, 6);
		const day = dateStr.slice(6, 8);

		return `${year}-${month}-${day}`;
	}

	return dateStr;
};
